import { useContext } from "react";
import { Handle } from "reactflow";
import DeleteIcon from "@mui/icons-material/Delete";
import NodeDeleteContext from "./NodeDeleteContext";

const ButtonNode = (props) => {
  const { selected, data } = props;

  const { onNodesDelete, nodes } = useContext(NodeDeleteContext);

  const handleDelete = () => {
    const findChildrens = nodes.filter((el) => props.id === el.parentId);
    const deleteArray = [props, ...findChildrens];
    onNodesDelete(deleteArray);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {selected && (
        <DeleteIcon
          onClick={handleDelete}
          sx={{
            fontSize: "15px",
            color: "red",
            position: "absolute",
            left: 0,
          }}
        />
      )}
      <div className="input-node">
        <div>{data.label}</div>
        <Handle type="source" position="right" />
      </div>
    </div>
  );
};

export default ButtonNode;
